module.exports = __webpack_public_path__ + "static/media/tish-transparent.008a6c0b.png";